import type { AccessLevelModel } from 'shared/domain/issue/mapping/accessLevel/model/types';
import type { UserAccess } from 'shared/domain/issue/mapping/accessLevel/toOnView/types';

export enum IssueAccessChangeKind {
  grant = 'grant',
  edit = 'edit',
  revoke = 'revoke',
}

export interface IssueAccessBody {
  accessLevel: AccessLevelModel;
  accessingUser: string;
}

/** A user's access to an issue: granted, changed or revoked. */
export type IssueAccessChange =
  | { kind: IssueAccessChangeKind.grant; issueId: string; body: IssueAccessBody }
  | { kind: IssueAccessChangeKind.edit; issueId: string; accessId: string; body: IssueAccessBody }
  | { kind: IssueAccessChangeKind.revoke; issueId: string; accessId: string };

/** The saved access, or: the user already had it (another admin granted it meanwhile). */
export type IssueAccessChangeResult = { access: UserAccess } | { alreadyGranted: true };

export function isAccessAlreadyGranted(result: IssueAccessChangeResult): result is { alreadyGranted: true } {
  return 'alreadyGranted' in result;
}
